import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState } from './selectors';
import { useCallback } from 'react';
import { togglePushSubscription } from './actions';
import { PushSubscriptionState } from './types';
import { CompliantLocalStorageKeys } from '../compliantLocalStorage/constants';
import { useBooleanLocalStorageValue } from '../compliantLocalStorage/hooks';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    const [isSubscribedLocally, setSubscribedLocally] = useBooleanLocalStorageValue(CompliantLocalStorageKeys.PWA_NOTIFICATIONS);
    // set initial value if unset
    if (state === PushSubscriptionState.SUBSCRIBED && !isSubscribedLocally) {
        setSubscribedLocally(true);
    }
    const dispatch = useDispatch();
    const toggleSubscription = useCallback(()=>{
        dispatch(togglePushSubscription());
        setSubscribedLocally(!isSubscribedLocally);
    }, [
        dispatch,
        setSubscribedLocally,
        isSubscribedLocally
    ]);
    return {
        state,
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED || isSubscribedLocally,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggleSubscription
    };
}

//# sourceMappingURL=hooks.js.map